import { lazy, Suspense, useState } from 'react';
import { Button } from 'antd';
import type { ButtonProps } from 'antd';
import clsx from 'clsx';
import Spin from 'components/Spin';
import If from 'components/If';
import { QaCreditCardCapture } from 'testdata/constants';
import styles from './index.module.scss';

const FinishAccountSetupModal = lazy(
  () => import('pages/finish-account-setup'),
);

interface Props extends ButtonProps {
  ctaText: string;
  onClickCallback?: () => Promise<void>;
}

function CompleteMySetupCta({
  ctaText,
  type = 'link',
  className,
  onClickCallback,
  ...rest
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const ctaClassName = clsx(className, {
    [styles.compleMySetupCta]: type === 'link',
  });

  const handleModalOpen = () => {
    setIsModalOpen(true);
    if (onClickCallback) {
      onClickCallback();
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        type={type}
        className={ctaClassName}
        {...rest}
        onClick={handleModalOpen}
        data-qa-selector={QaCreditCardCapture.buttonCompleteSetup}
      >
        {ctaText}
      </Button>
      <If condition={isModalOpen}>
        <Suspense fallback={<Spin fullscreen />}>
          <FinishAccountSetupModal
            isOpen
            step={1}
            handleClose={handleModalClose}
          />
        </Suspense>
      </If>
    </>
  );
}

export default CompleteMySetupCta;
